module.exports = __webpack_public_path__ + "static/media/logo4.e5fa157a.png";